import React, { CSSProperties, FC } from 'react';
import styled from 'styled-components';

type Props = {
  src: any;
  size: number;
  style?: CSSProperties;
  alt?: string;
};

const Wrapper = styled.div<{ size: number }>`
  display: flex;
  flex-shrink: 1;
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
  border-radius: ${({ size }) => size}px;
  border-style: hidden;
  overflow: hidden;
`;

const Img = styled.img<{ size: number }>`
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
  object-fit: cover;
`;

export const RoundImage: FC<Props> = ({ src, size, alt = '', style }) => {
  return (
    <Wrapper size={size} style={style}>
      <Img src={src} size={size} alt={alt} loading="lazy" />
    </Wrapper>
  );
};
